import { defaultDarkBackgroundThreshold } from '../consts';
import { parseColor } from './parse-color';

export const isDarkColor = (r: number, g: number, b: number): boolean => {
  return r * 0.299 + g * 0.587 + b * 0.25 < defaultDarkBackgroundThreshold;
};

export const isDarkColorFromString = (color: string): boolean => {
  if (!color) return false;
  const { r, g, b } = parseColor(color);
  return isDarkColor(r, g, b);
};
